import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type NetworkPlacement } from "./types";

const reducer = (state: NetworkPlacement.State = defaultState, action: ReduxAction<any>): NetworkPlacement.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { placementSettingOptions, settings } = action.data as InitSuccessActionData;
      return {
        ...state,
        placementSettingOptions,
        settings,
        status: Status.Ready
      };
    }

    case Actions.SaveBegin: {
      return {
        ...state,
        error: null,
        status: Status.Saving
      };
    }
    case Actions.SaveFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: Status.Ready
      };
    }
    case Actions.SaveSuccess: {
      return {
        ...state,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: NetworkPlacement.State = {
  error: null,
  id: "",

  placementSettingOptions: [],
  status: Status.None,
  settings: []
};
export const previewState: NetworkPlacement.State = {
  ...defaultState,
  placementSettingOptions: [],
  status: Status.Ready,
  settings: []
};
export default wrapReducer({ defaultState, reducer, previewState });
